"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSteps = void 0;
const stepCount = 100;
const createStepsDeterministic = () => {
    let stepArr = [];
    for (let i = 0; i < stepCount; ++i) {
        stepArr.push({
            name: "step_no_" + (i + 1).toString(),
            nextPossibleSteps: i < stepCount - 1 ? ["step_no_" + (i + 2).toString()] : undefined,
            run: ($wizard) => {
                return new Promise((resolve) => {
                    $wizard.synWizard("enableNextButton", true);
                    resolve();
                });
            },
            getNextStepName: (_$wizard) => i < stepCount - 1 ? "step_no_" + (i + 2).toString() : undefined,
            cleanup: (_$wizard) => Promise.resolve(),
            hideBtnCancel: false,
            hideBtnPrevious: false,
            hideBtnNext: false
        });
    }
    return stepArr;
};
const link = (parent, child) => {
    parent.nextPossibleSteps.push(child.name);
    const allNextPossibleSteps = parent.nextPossibleSteps.slice();
    parent.getNextStepName = (_$this) => Promise.resolve(allNextPossibleSteps[Math.floor(Math.random() * allNextPossibleSteps.length)]);
};
const createStepsNonDeterministic = () => {
    const stepArr = [];
    for (let i = 0; i < stepCount * 10; ++i) {
        const curStep = {
            name: "step_no_" + (i + 1).toString(),
            run: ($wizard) => {
                return new Promise((resolve) => {
                    $wizard.synWizard("enableNextButton", true);
                    resolve();
                });
            }
        };
        stepArr.push(curStep);
        const lastIdx = stepArr.length - 1;
        const remainingArray = stepArr.filter((_v, idx) => idx != lastIdx);
        if (remainingArray.length) {
            const randomParent = remainingArray[Math.floor(Math.random() * remainingArray.length)];
            link(randomParent, curStep);
        }
    }
    return stepArr;
};
const createSteps = (deterministic) => {
    if (deterministic)
        return createStepsDeterministic();
    return createStepsNonDeterministic();
};
exports.createSteps = createSteps;
